<template>
    <div class="card-body px-0 pt-0 pb-3">
        <div class="table-responsive">
            <el-table border :data="this.data" class="el-table-css" style="width: 100%">
                <el-table-column label="Təklif nömrəsi" width="300">
                    <template #default="scope">
                        <div class="row">
                            <div class="col-sm-6">
                                <a class="number-link" style="color: #007bff;" @click="GoToQuota(scope.row.quotaId)">{{
                                    scope.row.quotaFullNumber }}</a>
                            </div>
                            <div class="col-sm-5">
                                <span style="margin-top: 6px;" class="badge badge-success">{{
                                    scope.row.quotaStatusName
                                }} </span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="quotaDateStr" label="Tarix" width="220" />
                <el-table-column prop="insured.name" label="Sığortalı" />
                <el-table-column prop="period" label="Müdət" width="120" />
                <el-table-column width="43">
                    <template #default="scope">
                        <el-popover style="max-width: 1000px !important;" :width="null" placement="right-start"
                            title="Info" trigger="hover" class="edit-btn">
                            <template #reference>
                                <el-button type="default" style="padding: 0 !important;" :icon="InfoFilled" text />
                            </template>
                            <template #default>
                                <div>
                                    Daxil olunub &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ scope.row.created }} <br>
                                    Düzəliş
                                    olunub &nbsp;&nbsp;&nbsp; {{ scope.row.updated }}
                                </div>
                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import {
    InfoFilled,
} from "@element-plus/icons-vue";

export default {
    props: {
        data: Array,
        refindex: Number,
        constindex: Number
    },
    data() {
        return {
            type: null,
            InfoFilled
        }
    },
    methods: {
        GetColor(statusId) {
            if (statusId === 0) return "black";
            if (statusId === 2 || statusId === 4) return "green";
            return "red";
        }
    }
}
</script> 